import { FC } from 'react';
import { Modal, Text } from '@hopskipdrive/react-components';
import { Button } from '@rideiq/shared/components/Button';
import { colorTokens } from '@rideiq/shared/components/variables';

interface IModal {
  isOpen: boolean;
  isSubmitting: boolean;
  onCancel: () => void;
  handleDelete: (contact?: RidersContact) => void;
  contact: RidersContact;
  riderFullName?: string;
}

export const DeleteModal: FC<IModal> = ({ isOpen, onCancel, contact, handleDelete, riderFullName, isSubmitting }) => {
  return (
    <Modal open={isOpen} data-testid="delete-contact-modal">
      <Modal.Title>Delete Contact</Modal.Title>
      <Modal.Content>
        <Text fontWeight={300} textColor="secondaryText">
          Are you sure? This will permanently delete{' '}
          <b style={{ color: colorTokens.text.dark, fontWeight: 500 }}>{contact.fullName}</b> from {riderFullName}
          &apos;s list of contacts.
        </Text>
      </Modal.Content>
      <Modal.Actions>
        <Button color="tertiary" onClick={onCancel} style={{ flexGrow: 0 }} loading={isSubmitting}>
          Cancel
        </Button>
        <Button
          color="primary"
          data-testid="delete-contact"
          onClick={() => handleDelete(contact)}
          style={{ flexGrow: 0 }}
          loading={isSubmitting}
        >
          {isSubmitting ? 'Deleting...' : 'Delete'}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
